import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/animations.css'; // Import animations
import App from './App';
import { ThemeProvider } from './context/ThemeContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
